import React from "react"
import { useLocation } from "@reach/router"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import Logo from "../Logo"
import DesktopMenu from "./DesktopMenu"
import MobileMenu from "./MobileMenu"
import { analyticsAction } from "/src/utils/analytics"
import { useLangPath } from "../../i18n/useLangPath"
import { languageCodes } from "../../i18n/config"

function Header() {
  const { pathname } = useLocation()
  const langPath = useLangPath()
  const url = pathname === "/service/" ? pathname : "/"

  let blogSlug = null
  let pageSlug = null

  // A language-prefixed path (/de/pricing/) is the same PAGE as its EN twin, so the
  // prefix comes off before the slug is read. Left on, the first segment IS the
  // language: every non-EN visitor reported fm_page=de, and the pricing page's
  // signups scattered across eleven values that named no page at all.
  const [firstSegment] = pathname.split("/").filter(Boolean)
  const pagePath = languageCodes.includes(firstSegment)
    ? pathname.slice(firstSegment.length + 1) || "/"
    : pathname

  if (pagePath.startsWith("/blog")) {
    const blogMatch = pagePath.match(/\/blog\/([^/?]+)/)
    // Bare /blog has no slug to match — "main" stands for the blog index itself.
    blogSlug = blogMatch ? blogMatch[1] : "main"
  } else {
    const pageMatch = pagePath.match(/\/([^/?]+)/)
    if (pageMatch) {
      pageSlug = pageMatch[1]
    }
  }

  // Which page hosted the click, not where the visitor came from - these are
  // links from our own site into our own app, so they carry fm_page/fm_cta and
  // deliberately no utm_*. See shared/src/utm-tracking.js#INTERNAL_UTM_SOURCES.
  const ctaParams = blogSlug
    ? `?fm_page=blog/${blogSlug}&fm_cta=header_menu`
    : pageSlug
      ? `?fm_page=${pageSlug}&fm_cta=header_menu`
      : "?fm_page=main&fm_cta=header_menu"

  const signInUrl = `https://app.filmustage.com/sign/in${ctaParams}`
  const signUpUrl = `https://app.filmustage.com/sign/up${ctaParams}`

  return (
    <header className="fixed w-full z-30 bg-fGray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-12 sm:h-14">
          {/* Site branding */}
          <div className="flex-shrink-0">
            {/* Logo */}
            <AnchorLink
              stripHash={true}
              to={`${langPath(url)}#home`}
              className="block"
              aria-label="Filmustage"
              onClick={() => analyticsAction("landing_home_click")}
            >
              <Logo />
            </AnchorLink>
          </div>

          {/* Desktop navigation */}
          <DesktopMenu {...{ signInUrl, signUpUrl }} />
          {/* Mobile menu */}
          <MobileMenu {...{ signInUrl, signUpUrl }} />
        </div>
      </div>
    </header>
  )
}

export default Header
